import { Table as AxdsTable } from "@axiell/ui-components";

type Props = {
	currentPage: number;
	limit: number;
	total: number;
	paginationLimit: number;
	loading?: boolean;
	onPageChange: (page: number) => void;
};

const PaginationBar = ({
	currentPage,
	limit,
	total,
	paginationLimit,
	loading,
	onPageChange,
}: Props) => {
	return (
		<div className="table-bottom">
			<AxdsTable.Bottom>
				<AxdsTable.Results
					className="table-results"
					start={(currentPage - 1) * limit + 1}
					end={Math.min(currentPage * limit, total)}
					total={total}
				/>
				<AxdsTable.Pagination
					className="table-pagination"
					initial={currentPage}
					limit={paginationLimit}
					onPageChange={onPageChange}
					total={total < limit ? 1 : Math.ceil(total / limit)}
					loading={loading}
				/>
			</AxdsTable.Bottom>
		</div>
	);
};

export default PaginationBar;
